import Tooltip from 'tooltip.js';

const defaultOptions = {
  arrowSelector: '.iono-tooltip-arrow',
  innerSelector: '.iono-tooltip-inner',
  template: '<div class="iono-tooltip" role="tooltip"><div class="iono-tooltip-arrow"></div><div class="iono-tooltip-inner"></div></div>'
};

/**
 * Tooltip plugin - wraps Tooltip.js
 * @param {Element} targetEl The element to apply the plugin to
 * @param {Object}  options  ExtraTooltip.js options
 */
function TooltipPlugin (targetEl, options = {}) {
  if (!targetEl.tooltip) {
    // build the tooltip plugin instance options
    options = Object.assign({}, {
      title: targetEl.dataset.tooltip,
      html: targetEl.hasAttribute('data-tooltip-html'),
      placement: targetEl.dataset.tooltipPlacement || 'top',
      container: targetEl.dataset.tooltipContainer ? document.querySelector(targetEl.dataset.tooltipContainer) : null,
      viewport: targetEl.dataset.tooltipViewport ? document.querySelector(targetEl.dataset.tooltipViewport) : null
    }, options);

    // build the tooltip instance options
    const tooltipOptions = Object.assign({}, defaultOptions, {
      title: options.title,
      html: options.html,
      placement: options.placement,
      container: options.container,
      boundariesElement: options.viewport || options.container
    });

    // create the tooltip and assign it to the target
    targetEl.tooltip = new Tooltip(targetEl, tooltipOptions);
  }

  return targetEl.tooltip;
}

/**
 * Event listener that lazily inits tooltips when the user hovers over tooltip targets
 * @param  {Object} options
 * @return {Function}
 */
function lazyInitTooltip (options) {
  return function (event) {
    if (event.target.hasAttribute('data-tooltip')) {
      TooltipPlugin(event.target, options).show();
    }
  };
}

/**
 * Initializes the plugin, setting up init options and starting the lazy init listener
 * @param  {Object} options Initial set of init options
 */
TooltipPlugin.init = function (options = {}) {
  options = Object.assign({ container: document.body }, options);
  const handler = lazyInitTooltip(options);

  options.container.addEventListener('mouseover', handler);
  return function () {
    options.container.removeEventListener('mouseover', handler);
  };
};

window.Tooltip = Tooltip;

export default TooltipPlugin;
